import type { PublicOfferView } from "@townsy/contracts";
import { useNavigate } from "react-router";
import { useTownSession } from "../../app/TownSessionContext";
import { useTownStore } from "../../state/store";

/**
 * Where the task buttons lead, in the 3D town or on a plain page (2D directory, /earn): the task dialog
 * is the same everywhere (mounted by the town layout and the page shell); "Go there" frames the store in
 * the town, or opens its page in the town when the visitor is on a plain page.
 */
export function useRewardNav() {
  const session = useTownSession();
  const navigate = useNavigate();
  const openTask = useTownStore((s) => s.openTask);
  const setUi = useTownStore((s) => s.setUi);
  const pending = useTownStore((s) => s.ui.transitionPending);
  return {
    inTown: Boolean(session),
    start(offer: PublicOfferView): void {
      openTask({ offer, attemptId: offer.activeAttemptId });
    },
    resume(attemptId: string, offer?: PublicOfferView | null): void {
      openTask({ attemptId, offer: offer ?? null });
    },
    openEarn(): void {
      if (session) setUi({ earnOpen: true, menuOpen: false });
      else navigate("/earn");
    },
    goThere(propertyId: string): void {
      setUi({ earnOpen: false });
      if (session) session.goToProperty(propertyId);
      else navigate(`/place/${encodeURIComponent(propertyId)}`);
    },
    goThereReason: session && pending ? "Moving between rooms…" : null,
  };
}
